import React, { useContext } from 'react';
import {
  DropdownFilter,
  InputDropdown,
} from 'src/components/dropdown-filter/DropdownFilter';
import { useTranslation } from 'react-i18next';
import { ListContext } from '../context';
import { CcvResult } from '../../authorization';
import { ItemFilter } from 'src/components/dropdown-filter/filter';
import { CheckboxList } from 'src/components/dropdown-filter/CheckboxList';

export const FilterCcvResult = () => {
  const { dispatch, filters } = useContext(ListContext);

  const { t } = useTranslation();

  const ccvResultItems = [CcvResult.MATCH, CcvResult.NO_MATCH].map((item) => ({
    value: item,
    label: t(`transactionsManagement.authorizations.ccvResult.${item}`),
  }));

  const itemToggle = (options: { checked: boolean; item: ItemFilter }) =>
    dispatch({
      type: options.checked
        ? 'ADD_CCV_RESULT_FILTER'
        : 'REMOVE_CCV_RESULT_FILTER',
      itemFilter: options.item,
    });

  const clearFilter = () => dispatch({ type: 'RESET_CCV_RESULT_FILTER' });

  return (
    <DropdownFilter
      title={t('transactionsManagement.authorizations.list.filters.ccvResult')}
      headerSecondaryLabel={t(
        'transactionsManagement.transactions.list.filters.numberSelected',
        { totalItems: filters.ccvResult.length }
      )}
      onClearFilter={clearFilter}
      trigger={(dropdownProps) => (
        <InputDropdown
          name="ccvResult"
          label={t(
            'transactionsManagement.authorizations.list.filters.ccvResult'
          )}
          placeholder={t(
            'transactionsManagement.transactions.list.filters.all'
          )}
          value={
            filters.ccvResult.length
              ? t(
                  'transactionsManagement.transactions.list.filters.numberSelected',
                  { totalItems: filters.ccvResult.length }
                )
              : ''
          }
          {...dropdownProps}
        />
      )}
    >
      <CheckboxList
        items={ccvResultItems}
        filters={filters.ccvResult}
        onItemToggle={itemToggle}
        totalItems={filters.ccvResult.length}
        heightClassName="h-auto"
      />
    </DropdownFilter>
  );
};
